module.exports = __webpack_public_path__ + "img/qa3.fa73cb79.jpg";